<template>
  <div
    ref="component"
    class="click-area"
    :class="{'-hoverable': hoverable}"
    @click="togglePrompt($event)"
  >
    <div
      class="clickable-txt"
      :class="{'-hide': replace && visible}"
    >
      <slot name="visible" />
    </div>
    <div
      class="prompt"
      :style="position"
      :class="{'-visible': visible, '-tooltip': !replace}"
    >
      <button
        v-if="!replace"
        ref="btn"
      >
        ✕
      </button>
      <slot name="prompt" />
    </div>
  </div>
</template>
<script>
// You may want to add `pointer-events: none `to the element in the "visible' slot, otherwise, you'll trigger tooglePrompt twice canceling the togglle of the `visible` value
export default {
  props: {
    hoverable: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      default: () => {},
    },
    replace: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.addEventListener('click', this.closeOnClickOutsideComponent)
  },
  destroyed() {
    window.removeEventListener('click', this.closeOnClickOutsideComponent)
  },
  methods: {
    closeOnClickOutsideComponent(ev) {
      if (this.replace && this.visible) {
        return
      }
      if (ev.target !== this.$refs.component) {
        this.visible = false
      }
    },
    togglePrompt(event) {
      if (this.hoverable || (this.replace && this.visible)) {
        return
      }
      if (this.buttonWasclicked(event.target)) {
        this.visible = false
        return
      }
      this.visible = !this.visible
    },
    buttonWasclicked(target) {
      return target === this.$refs.btn
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.click-area {
  &:not(.-hoverable) {
    cursor: pointer;
  }

  position: relative;
}

.prompt {
  display: none;

  &.-tooltip {
    background: white;
    border: 1px solid $c-edward;
    inset: inherit !important;
    padding: 30px 10px 10px;
    position: absolute;
    right: 0 !important;
    top: -72px !important;
    width: 240px;
    z-index: 1;

    .-hoverable & {
      padding: 10px;
    }
  }

  .-hoverable:hover &,
  &.-visible {
    display: block;
    //margin-bottom: 30px;
  }
}

button {
  background: white;
  border: none;
  color: black;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;

  .-hoverable & {
    display: none;
  }
}

.clickable-txt {
  pointer-events: none;

  .-hoverable & {
    pointer-events: auto;
  }

  &.-hide {
    display: none;
  }
}
</style>
